import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      display: 'flex',
      flexFlow: 'column nowrap',
      gap: theme.spacing(1),

      '&:hover': {
        '& $content:not([disabled])': {
          borderColor: COLORS.gray.gray30,
        },

        '& $actions': {
          opacity: 1,
          pointerEvents: 'auto',
        },
      },

      '&$selected': {
        '& $content': {
          borderColor: COLORS.primary.active,
        },
      },
    },
    selected: {},

    content: {
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'stretch',
      gap: theme.spacing(1.5),
      padding: theme.spacing(1, 1, 1.5, 1),
      border: theme.shape.borderGray70,
      borderRadius: theme.shape.borderRadius,
    },
    cardImages: {
      height: 122,
    },
    title: {},
    actions: {
      position: 'absolute',
      top: theme.spacing(1.5),
      right: theme.spacing(1.5),
      display: 'flex',
      flexFlow: 'column nowrap',
      gap: theme.spacing(0.5),
      opacity: 0,
      pointerEvents: 'none',
    },
    editButton: {
      color: COLORS.gray.black,
      backgroundColor: COLORS.gray.white,
      border: theme.shape.borderGray60,
      boxShadow: theme.shape.boxShadowSmall,
    },
    deleteButton: {
      color: COLORS.error.active,
      backgroundColor: COLORS.gray.white,
      border: theme.shape.borderGray60,
      boxShadow: theme.shape.boxShadowSmall,
    },
    footer: {
      display: 'flex',
      flexFlow: 'row nowrap',
      gap: theme.spacing(0.5),
    },
    visualLanguageName: {
      color: COLORS.gray.gray50,
    },
  }),
  { name: 'ImageStyleCard' }
);
